import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCategoryAvailableCourseApproveById, fetchCategoryCourseApproveById, fetchCategoryAvailableCourseById, fetchCategoryCourseById, fetchClientProcedureAvailableCourseById, fetchClientProcedureCourseById, fetchHomologousProcedureAvailableCourseById, fetchHomologousProcedureCourseById, fetchTestAvailableCourseById, fetchTestCourseById, fetchWorkCycleAvailableCourseById, fetchWorkCycleCourseById } from 'app/actions/CourseActions';
import { getIsLoadingCourseTestAvailable, getCourseCategory, getCourseCategoryAvailable, getCourseClientProcedure, getCourseClientProcedureAvailable, getCourseHomologousProcedure, getCourseHomologousProcedureAvailable, getCourseTestAvailable, getCourseTest, getCourseWorkCycleAvailable, getCourseWorkCycle, getIsLoadingCourseCategory, getIsLoadingCourseClientProcedureAvailable, getIsLoadingCourseHomologousProcedureAvailable, getIsLoadingCourseWorkCycleAvailable } from 'app/reducers';
import isEmpty from 'app/utils/IsEmpty';
import { getTrainingSelect } from "app/actions/TrainingActions";
import { getSystemSpecialty } from "app/actions/SystemActions";

export default function EditCourseContainer(props) {
    const dispatch = useDispatch();
    let courseCategoryAvailable = useSelector(getCourseCategoryAvailable)
    let courseCategory = useSelector(getCourseCategory)
    let courseClientProcedureAvailable = useSelector(getCourseClientProcedureAvailable)
    let courseClientProcedure = useSelector(getCourseClientProcedure)
    let courseHomologousProcedureAvailable = useSelector(getCourseHomologousProcedureAvailable)
    let courseHomologousProcedure = useSelector(getCourseHomologousProcedure)
    let courseTestAvailable = useSelector(getCourseTestAvailable)
    let courseTest = useSelector(getCourseTest)
    let courseWorkCycleAvailable = useSelector(getCourseWorkCycleAvailable)
    let courseWorkCycle = useSelector(getCourseWorkCycle)
    let isLoading = useSelector(getIsLoadingCourseCategory);
    let isLoadingCourseClientProcedureAvailable = useSelector(getIsLoadingCourseClientProcedureAvailable);
    let isLoadingCourseHomologousProcedureAvailable = useSelector(getIsLoadingCourseHomologousProcedureAvailable);
    const loadingTest = useSelector(getIsLoadingCourseTestAvailable);
    const isLoadingWorkCycle = useSelector(getIsLoadingCourseWorkCycleAvailable);

    const { trainingSelect } = useSelector(state => state.TrainingReducer)
    const { systemSpecialty } = useSelector(state => state.SystemReducer)
    const {
        idSubdirection,
        employeeId
    } = useSelector(state => state.Auth.employeeById)

    const {
        allCourseCategoryAvailableApprove,
        allCourseCategoryApprove, 
        isLoadingApprove
    } = useSelector(state => state.Course)

    useEffect(() => {
        if (isEmpty(courseTest)) fetchCourseTestAction();
        if (isEmpty(courseWorkCycle)) fetchCourseWorkCycleAction();
        if (isEmpty(courseTestAvailable)) fetchCourseTestAvailableAction();
        if (isEmpty(courseWorkCycleAvailable)) fetchCourseWorkCycleAvailableAction();
        if (isEmpty(courseCategory)) fetchCourseCategoryAction();
        if (isEmpty(courseCategoryAvailable)) fetchCourseCategoryAvailableAction();

        if (isEmpty(allCourseCategoryApprove)) fetchCourseCategoryApproveAction();
        if (isEmpty(allCourseCategoryAvailableApprove)) fetchCourseCategoryAvailableApproveAction();

        if (isEmpty(courseClientProcedureAvailable)) fetchCourseClientProcedureAvailableAction();
        if (isEmpty(courseClientProcedure)) fetchCourseClientProcedureAction();
        if (isEmpty(courseHomologousProcedureAvailable)) fetchCourseHomologousProcedureAvailableAction();
        if (isEmpty(courseHomologousProcedure)) fetchCourseHomologousProcedureAction();
        if(isEmpty(trainingSelect)) fetchTrainingSelect();
        if(isEmpty(systemSpecialty)) fetchSystemSpecialty();
    }, []);

    const fetchCourseCategoryAvailableAction = () => dispatch(fetchCategoryAvailableCourseById({
        idCourse: props.filterData.idCourse,
        isApprover: false,
        idSubdirection: idSubdirection
    }));

    const fetchCourseCategoryAction = () => dispatch(fetchCategoryCourseById({
        idCourse: props.filterData.idCourse,
        isApprover: false
    }));

    const fetchCourseCategoryAvailableApproveAction = () => dispatch(fetchCategoryAvailableCourseApproveById({
        idCourse: props.filterData.idCourse,
        isApprover: true,
        idSubdirection: idSubdirection
    }));
    
    const fetchCourseCategoryApproveAction = () => dispatch(fetchCategoryCourseApproveById({
        idCourse: props.filterData.idCourse,
        isApprover: true
    }));

    const fetchCourseClientProcedureAvailableAction = () => dispatch(fetchClientProcedureAvailableCourseById(props.filterData.idCourse));
    const fetchCourseClientProcedureAction = () => dispatch(fetchClientProcedureCourseById(props.filterData.idCourse));

    const fetchCourseHomologousProcedureAvailableAction = () => dispatch(fetchHomologousProcedureAvailableCourseById(props.filterData.idCourse));
    const fetchCourseHomologousProcedureAction = () => dispatch(fetchHomologousProcedureCourseById(props.filterData.idCourse));

    const fetchCourseTestAvailableAction = () => dispatch(fetchTestAvailableCourseById(props.filterData.idCourse, props.filterData.idTraining));
    const fetchCourseTestAction = () => dispatch(fetchTestCourseById(props.filterData.idCourse));

    const fetchCourseWorkCycleAvailableAction = () => dispatch(fetchWorkCycleAvailableCourseById(props.filterData.idCourse));
    const fetchCourseWorkCycleAction = () => dispatch(fetchWorkCycleCourseById(props.filterData.idCourse));
    
    const fetchTrainingSelect = () => dispatch(getTrainingSelect(employeeId));
    const fetchSystemSpecialty = () => dispatch(getSystemSpecialty(idSubdirection));
    
    const coursesCategoryAsig = courseCategory; //Asignados colaborador
    const coursesCategory = courseCategoryAvailable.concat(courseCategory); //Todas las categorias colaborador

    const coursesCategoryApproveAsig = allCourseCategoryApprove; //Asignados aprobadores
    const coursesCategoryApprove = allCourseCategoryAvailableApprove.concat(allCourseCategoryApprove); //Todas las categorias aprobadores
    
    const coursesClientProcedureAsig = courseClientProcedure.map(i => i.idProcedure)
    const coursesClientProcedure = courseClientProcedureAvailable.concat(courseClientProcedure);

    const coursesHomologousProcedureAsig = courseHomologousProcedure.map(i => i.idProcedure)
    const coursesHomologousProcedure = courseHomologousProcedureAvailable.concat(courseHomologousProcedure);
    const coursesTestAsig = courseTest.map(i => i.idTest)
    const coursesTest = courseTestAvailable.concat(courseTest);

    const coursesWorkCycleAsig = courseWorkCycle.map(i => i.idTest)
    const coursesWorkCycle = courseWorkCycleAvailable;//.concat(courseWorkCycle);

    coursesCategory.map(item => item['key'] = item.idCategory);
    coursesCategoryApprove.map(item => item['key'] = item.idCategory);

    coursesClientProcedure.forEach(item => {
        item['key'] = item.idProcedure
        item['disabled'] = false
    });
    coursesHomologousProcedure.map(item => item['key'] = item.idProcedure);
    coursesTest.map(item => item['key'] = item.idTest);
    coursesWorkCycle.map(item => item['key'] = item.idTest);
    return (props.children({ loadingTest, isLoadingApprove, coursesCategory, coursesCategoryAsig, coursesCategoryApprove, coursesCategoryApproveAsig, coursesClientProcedure, coursesClientProcedureAsig, coursesHomologousProcedure, coursesHomologousProcedureAsig, coursesTest, coursesTestAsig, coursesWorkCycle, coursesWorkCycleAsig, isLoading, isLoadingCourseClientProcedureAvailable, isLoadingCourseHomologousProcedureAvailable, isLoadingWorkCycle }));
}